module.exports = __webpack_public_path__ + "/images/logo-af-tutete.f823394.png";